export default __webpack_public_path__ + "static/media/12.26e6deab.png";